import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/journey/milao-navigli-poster.jpg")